<template>
  <div class="container"></div>
</template>
<script>
export default {
  components: {},
  data() {
    return {};
  },
  watch: {},
  mounted() {
    this.goManage();
  },
  methods: {},
};
</script>

<style lang="scss" scoped></style>
